var $ = require('jquery');

module.exports = (function() {
	var $cart = $('.cart--full');

	$cart.each(function() {
		var $form = $(this),
			url = this.dataset.urlUpdate,
			cartTimeout;

		$form.on('click', '.cart-item-count .minus, .cart-item-count .plus', function(e) {
			var $this = $(this),
				$input = $this.parent().find('input'),
				$btnPlus = $this.parent().find('.plus'),
				value = parseInt($input.val());

			e.preventDefault();
			e.stopPropagation();

			if(isNaN(value)) {
				value = 0;
			}

			$btnPlus.removeAttr('disabled');

			if($this.hasClass('minus') && value > 1) {
				value--;
			}
			else
			if($this.hasClass('plus')) {
				if(value < $input[0].dataset.maxValue) {
					value++;
				} else {
					alert('Доступно для заказа: ' + $input[0].dataset.maxValue);
					$btnPlus.attr('disabled', 'disabled');
				}
			}

			$input.val(value);

			$input.trigger('change');

			clearTimeout(cartTimeout);

			cartTimeout = setTimeout(function() {
				if($input[0].dataset.value != $input[0].value && $input[0].dataset.originalValue != $input[0].value ) {
					clearTimeout(cartTimeout);
					$form.trigger('cart:update');
				}
			}, 3000);

		}).on('change', '.cart-item-count input', function(e) {
			var value = parseInt(this.value);

			if(isNaN(value) || value == 0) {
				this.value = 1;
			}
		}).on('cart:update', function() {
			$form.addClass('cart--load');

			$.ajax({
				'url': url,
				'data': $form.serialize(),
				'type': 'post',
				'dataType': 'json'
			}).done(function(data) {

				$form.removeClass('cart--load');

				$form.html($(data.htmlCart).html());

				document.querySelector('.header__cart').outerHTML = data.htmlHeaderCart;

				document.querySelector('.topline__item--cart').outerHTML = data.htmlToplineCart;

				$('[type="tel"]').mask('+7 (999) 999-99-99');
			});
		}).on('focusin', '[name^=items]', function() {
			var input = this;

			this.dataset.value = this.value;

			clearTimeout(cartTimeout);

			cartTimeout = setTimeout(function() {
				if(input.dataset.value != input.value && input.dataset.originalValue != input.value && ! (isNaN(input.value) || input.value == 0)) {
					clearTimeout(cartTimeout);
					$form.trigger('cart:update');
				}
			}, 3000);
		}).on('focusout', '[name^=items]', function(e) {
			var value = parseInt(this.value);

			if(isNaN(value) || value == 0) {
				this.value = 1;
				e.preventDefault();
				e.stopPropagation();
				return;
			}

			if(value > this.dataset.maxValue) {
				alert('Доступно для заказа: ' + this.dataset.maxValue);
				this.value = this.dataset.maxValue;
			}

			if(this.dataset.value != this.value) {
				$form.trigger('cart:update');
			}
		}).on('change', '.cart-item-clear :checkbox', function(e) {
			e.preventDefault();
			e.stopPropagation();

			if(confirm(this.title)) {
				$form.trigger('cart:update');
			}
		});
	});
})();
